import React from "react";
import './home_tres.css';
import Dot from '../../../assets/imgs/home_siete/Dot.png'
import renctgle from '../../../assets/imgs/home_tres/rectangulo.png'
import rbss from '../../../assets/img/RS_2.png'
import { useTranslation } from "react-i18next";

 const Home_tres = () =>  {
    
    const [t] = useTranslation("home");

    return (
        <div className='sobre-rbs'>

            <div className="contenedor escritorio">
                <div className="column1">
                    <div className="mitad-text  letrero" >
                        <div dangerouslySetInnerHTML={{__html: (t('view-points.quote'))}}></div>
                        {/* <p><span className="text-medium">En 2008 comencé a compartir mis</span><br />
                            <span className="text-high">ideas y puntos de vista</span><br />
                            sobre diversos temas. El mundo se mueve
                            rápidamente y debemos pensar cómo lograr
                            que estalle un verdadero cambio cultural.</p>
                        <p className="nombre"><b>Ricardo B. Salinas</b></p> */}
                    </div>
                    <div className="mitad-text circulo">
                        <img src="https://www.ricardosalinas.com/Content/assets/img/Ellipse 306.svg" alt="Imagen de fondo" className="elipse" />
                        <img className="H3_dot" src={Dot} id='H3_dot-animated' alt='Elipse'/>
                    </div>
                </div>
                <div className="column2">
                    {/* <div className=" " >
        <div className="col"> */}
                    <img src={renctgle} alt="Imagen de fondo" className="H3_img_fond" />

                    {/* </div>
      </div> */}
                    <img src={rbss} alt="Imagen superpuesta" className="rbs" />
                </div>
            </div>



            <div className="conten2 movil" >

                <div className="column-movil">
                    <img src="/assets/img/Rectangulo Gris.svg" alt="Imagen de fondo" className="H3_img_fond2" />
                    <img src={rbss} alt="Imagen superpuesta" className="rbs2" />
                </div>

                <div className="text-movil" >
                    <div dangerouslySetInnerHTML={{__html: (t('view-points.quote-mobile'))}}></div>
                    <img src="https://www.ricardosalinas.com/Content/assets/img/Ellipse 306.svg" alt="Imagen de fondo" className="H3_elipse-movil" />
                    <img className="H3_dot-movil" src={Dot} id='H3_dot-animated-movil'/>

                </div>


            </div>

        </div>

    );



}

export default Home_tres;